module.exports = __webpack_public_path__ + "media/control_acceso/puerta_automatica-ff74a2c5.png";